import { Component, OnDestroy, OnInit } from '@angular/core';
import Highcharts from 'highcharts';
import { ChartDataObject } from '../../core/models/chart.model';
import { ChartService } from '../../core/services/chart/chart.service';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrl: './devices.component.scss'
})
export class DevicesComponent implements OnInit, OnDestroy {
  chartConfig: Highcharts.Options | undefined;
  chartDetailConfig: Highcharts.Options | undefined;
  showDetailChart: boolean = false;
  chartData!: ChartDataObject;
  loading = false;
  
  private subscriptions: Subscription = new Subscription();

  constructor(private chartService: ChartService, private translocoSrv: TranslocoService) {}

  ngOnInit() {
    this.subscriptions.add(
      this.chartService.devicesSerie$.subscribe(indexSerie => {
        if(indexSerie !== undefined) {
          this.generateDevicesDetailChart(indexSerie);
        }
    }));
    this.subscriptions.add(
      this.translocoSrv.events$.subscribe(event => {
        if(event.type === 'translationLoadSuccess') {
          this.reloadCharts();
        } else {
          if(Object.keys(this.translocoSrv.getTranslation(this.translocoSrv.getActiveLang())).length) {
            this.reloadCharts();
          }
        }
    }));
    this.loading = true;
    this.subscriptions.add(
      this.chartService.loadDevicesChartData().subscribe({
        next: () => {
          this.loading = false;
          this.generateDevicesChart();
        },
        error: () => {
          this.loading = false;
          this.generateDevicesChart();
        }
      })
    );
  }

  reloadCharts() {
    this.generateDevicesChart();
    if(this.showDetailChart) this.generateDevicesDetailChart(this.chartService.getDevicesSerie());
  }

  generateDevicesChart() {
    this.showDetailChart = false;
    this.chartService.setDevicesChartSeries();
    this.chartConfig = this.chartService.getDevicesChartConfig();
  }

  generateDevicesDetailChart(indexSerie: number) {
    this.showDetailChart = true;    
    this.chartService.setDevicesDetailChartSeries(indexSerie);
    this.chartDetailConfig = this.chartService.getDevicesDetailChartConfig(indexSerie);
  }
  
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
